import { Components, Theme } from '@mui/material/styles';
import DefaultPaletteOptions from 'theming/defaultPalette';

export default (palette: DefaultPaletteOptions): Components<Theme>['MuiAppBar'] => ({
  styleOverrides: {
    root: {
      background: palette.primary?.main,
      height: '58px'
    }
  }
});
